import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { createUserWithEmailAndPassword } from 'firebase/auth';

import { auth } from '../firebase/config';
import { useAuth } from '../context/AuthContext';

import PublicHeader from '../components/Header/PublicHeader';
import PublicFooter from '../components/Footer/PublicFooter';
import GoogleLoginButton from '../components/common/GoogleLoginButton';
import Button from '../components/ui/Button';

import './Signup.css';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const { refreshProfile, setTenant } = useAuth();

  const selectedPlan = new URLSearchParams(location.search).get('plan');

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const userCred = await createUserWithEmailAndPassword(auth, email, pass);
      const token = await userCred.user.getIdToken();

      const profile = await refreshProfile(token);
      if (profile && setTenant) {
        setTenant(profile);
      }

      if (selectedPlan && selectedPlan.toUpperCase() !== 'FREE') {
        navigate(`/checkout?plan=${selectedPlan}`);
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      const message = err?.message || 'Signup failed';
      setError(message);

      if (message.includes('email-already')) {
        navigate('/login');
      }
    }
  };

  return (
    <>
      <PublicHeader />

      <section className="signup-page">
        <div className="container">
          <div className="signup-card">
            <h1 className="signup-title">Create your account</h1>
            <p className="signup-subtitle">
              Start securing your data with Vaultize
            </p>

            {error && <div className="signup-error">{error}</div>}

            <form onSubmit={handleSignup} className="signup-form">
              <input
                className="input"
                type="email"
                placeholder="Work email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <input
                className="input"
                type="password"
                placeholder="Password"
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                required
              />

              <Button type="submit" variant="primary">
                Create Account
              </Button>
            </form>

            <div className="signup-divider">OR</div>

            <GoogleLoginButton />

            <div className="signup-footer">
              Already have an account? <Link to="/login">Login</Link>
            </div>
          </div>
        </div>
      </section>

      <PublicFooter />
    </>
  );
};

export default Signup;
